<template>
  <div class="container">
    <div class="left">
      <div class="video-container">
        <resize-observer @notify="handleResize" />
        <bg-eye-tracker
          v-if="totalTime"
          :key="eyeTrackerKey"
          :data="data"
          :currentTime="currentTime"
          :totalTime="totalTime"
          :testPlatform="testPlatform"
        />
        <bg-video-player
          :video="data.video"
          :getRef="setVideoRef"
          :currentTime="currentTime"
          :timeUpdate="timeUpdate"
          :newScrubberTime="newScrubberTime"
          :updateMetaData="handleVideoLoad"
          :customControls="true"
        />
      </div>
      <simple-scrubber
        v-if="videoRef"
        :key="scrubberKey"
        :scrubberTimeChange="setNewTime"
        :currentTime="currentTime"
        :videoRef="videoRef"
        :data="data"
        :sections="sections"
        :active-section-id="activeSectionId"
        mouseDownTrigger
        @currentSectionChange="handleCurrentSectionChange"
        @scrubberMouseUp="handleMouseUp"
      ></simple-scrubber>
      <div class="buttons">
        <div
          class="buttons__button buttons__button--start"
          @click="handlePressStart"
        >
          Start
        </div>
        <div
          class="buttons__button buttons__button--end"
          @click="handlePressEnd"
        >
          End
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  position: relative;
  display: flex;
  float: left;
  width: 78%;

  // @media (min-width: 576px) {
  //   max-width: 100%;
  // }
}

.left {
  width: 100%;
}

.legend {
  flex-direction: row-reverse;
  padding-bottom: 20px;
}

.chart-container {
  width: 100%;
  height: 160px;
  position: relative;
  margin-top: 15px;
}

.video-container {
  position: relative;
}

.neuro-container {
  height: 100%;
  margin-left: 15px;
  @media (min-width: 576px) {
    width: 45%;
  }
  @media (min-width: 768px) {
  }

  @media (min-width: 992px) {
  }

  @media (min-width: 1200px) {
    width: 20%;
  }
}
.buttons {
  width: 400px;
  justify-content: space-between;
  display: flex;
  margin-bottom: 100px;
  &__button {
    text-align: center;
    font-weight: bold;
    width: 191px;
    height: 40px;
    border-radius: 6px;
    padding-top: 10px;
    cursor: pointer;
    &:active {
      opacity: 0.7;
    }
    &--start {
      background-color: #00deab;
    }
    &--end {
      background-color: #0b0b3d;
      color: white;
    }
  }
}
</style>

<script>
import BgVideoPlayer from "@/components/bg-video-chart/bg-video-player";
import BgEyeTracker from "@/components/bg-video-chart/bg-eye-tracker";
import SimpleScrubber from "@/components/video-player/simple-scrubber";

export default {
  name: "videoPlayer",
  components: {
    BgVideoPlayer,
    BgEyeTracker,
    SimpleScrubber,
  },
  props: {
    data: Object,
    customControls: false,
    testId: {
      type: Number,
      optional: true,
    },
    sections: {
      type: Array,
      default: () => [],
    },
    activeSectionId: {
      type: Number,
      default: null,
    },
    getRef: {
      type: Function,
      required: true,
    },
    testPlatform: {
      type: String,
      optional: true,
    },
  },
  methods: {
    setVideoRef(ref) {
      this.videoRef = ref;
      this.getRef(ref);
    },
    timeUpdate(time) {
      this.currentTime = time;
      this.$emit("timeUpdate", time);
    },
    setNewTime(newTimePercentage) {
      this.newScrubberTime = this.videoRef.duration * newTimePercentage;
    },
    handleVideoLoad(video) {
      if (video) {
        if (this.$route.query.timestamp) {
          const startTime = moment(this.data.started_at);
          const endTime = moment(this.data.ended_at);
          const startPos = moment(Number(this.$route.query.timestamp));
          const videoLength = endTime.diff(startTime, "seconds");
          const timeElapsed = startPos.diff(startTime, "seconds");
          this.setNewTime(timeElapsed / videoLength);
        }
        this.totalTime = video.duration;
      }
    },
    handleNueroPop(point) {
      if (this.nueroBubbles.find((nb) => (nb.id = point.id))) {
        return null;
      } else {
        this.nueroBubbles.push(point);
      }
    },
    handleResize() {
      this.eyeTrackerKey += 1;
      this.scrubberKey += 1;
    },
    handlePressStart() {
      this.$emit("pressStart", this.currentTime);
    },
    handlePressEnd() {
      this.$emit("pressEnd", this.currentTime);
    },
    handleMouseUp() {
      this.$emit("scrubberMouseUp");
    },
    handleCurrentSectionChange(section) {
      this.$emit("currentSectionChange", section);
    },
  },
  data() {
    return {
      videoRef: null,
      totalTime: 0,
      currentTime: 0,
      newScrubberTime: 0,
      nueroBubbles: [],
      eyeTrackerKey: 1,
      scrubberKey: 2,
    };
  },
};
</script>
